<template>
  <div id="app" :key="localeKey">
    <a href="#main" class="skip-link">{{ $t('nav.skipToContent') }}</a>
    <NavBar />
    <main id="main" tabindex="-1">
      <router-view :key="localeKey" />
    </main>
    <Footer/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Footer from "@/components/AppFooter.vue";
import { useI18n } from 'vue-i18n';
import { ref, onMounted, onUnmounted, watch } from 'vue';

export default {
  components: {Footer, NavBar },
  setup() {
    const { locale } = useI18n();
    const localeKey = ref(locale.value);

    // De taal van de pagina moet meelopen met de gekozen taal, anders leest
    // een schermlezer Engelse of Spaanse tekst voor met een Nederlandse stem.
    const setDocumentLang = (lang) => { document.documentElement.lang = lang; };
    setDocumentLang(locale.value);

    // Watch for locale changes
    watch(() => locale.value, (newLocale) => {
      localeKey.value = newLocale;
      setDocumentLang(newLocale);
    });
    
    // Listen for language-changed events
    const handleLanguageChange = (event) => {
      const newLocale = event.detail.locale;
      locale.value = newLocale;
      localeKey.value = newLocale;
    };
    
    onMounted(() => {
      window.addEventListener('language-changed', handleLanguageChange);
      localeKey.value = locale.value;
    });
    
    onUnmounted(() => {
      window.removeEventListener('language-changed', handleLanguageChange);
    });
    
    return {
      localeKey
    };
  }
}
</script>

<style>
#app {
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--body);
  min-height: 100vh;
}
</style>
